import { IconInstagramNegative, IconLinkedInNegative, IconTelegramNegative } from '@/features/icons';
import { InstagramUrl, LinkedinUrl, TelegramUrl } from '@/app/_constants/brand-contact';
import { CafeBazaarDownloadUrl, IAppsDownloadUrl, MykeyDownloadUrl, SibAppDownloadUrl, SibIraniDownloadUrl, SibcheDownloadUrl } from '@/app/_constants/third-parties';
import { getCdnUrl } from '@/utils/url';
import { Link, LinkCollection } from './type';
export const faqLinks: LinkCollection[] = [];
export const links: LinkCollection[] = [{
  title: 'خدمات مشتریان',
  collection: [{
    title: 'پرسش‌های متداول',
    url: '/faq'
  }, {
    title: 'راهنمای خرید و پرداخت',
    url: '/faq?category=order'
  }, {
    title: 'رویه‌های ارسال',
    url: '/faq?category=delivery'
  }, {
    title: 'شرایط مرجوعی',
    url: '/faq?category=return'
  }, {
    title: 'خرید کالای شانس',
    url: '/faq?category=chance'
  }, {
    title: 'ارتباط با پشتیبانی',
    url: '/profile/support'
  }]
}, {
  title: 'شرکت خانومی',
  collection: [{
    title: 'تماس با ما',
    url: '/contact-us'
  }, {
    title: 'درباره ما',
    url: '/about-us'
  }, {
    title: 'فرصت‌های شغلی',
    url: 'https://careers.khanoumi.com'
  }, {
    title: 'حریم خصوصی',
    url: '/privacy'
  }, {
    title: 'مجله خانومی',
    url: 'https://www.khanoumi.com/blog/'
  }, {
    title: 'کارت هدیه سازمانی',
    url: 'https://www.khanoumi.com/landing/giftcard-org'
  }, {
    title: 'خانومی بیزینس',
    url: 'https://www.khanoumi.com/business/'
  }, {
    title: 'خانومی TV',
    url: 'https://www.khanoumi.com/tv/'
  }]
}];
export const appDownloadLinks = [{
  title: 'دریافت از کافه بازار',
  url: CafeBazaarDownloadUrl,
  imageUrl: getCdnUrl('/_toad/images/footer/download-from-cafe-bazaar.png')
}, {
  title: 'دریافت از مایکت',
  url: MykeyDownloadUrl,
  imageUrl: getCdnUrl('/_toad/images/footer/download-from-myket.png')
}, {
  title: 'دریافت از سیب اپ',
  url: SibAppDownloadUrl,
  imageUrl: getCdnUrl('/_toad/images/footer/download-from-sibapp.png')
}, {
  title: 'دریافت از سیبچه',
  url: SibcheDownloadUrl,
  imageUrl: getCdnUrl('/_toad/images/footer/download-from-sibche.png')
}, {
  title: 'دریافت از آی اپس',
  url: IAppsDownloadUrl,
  imageUrl: getCdnUrl('/_toad/images/footer/download-from-iapps.png')
}, {
  title: 'دریافت از سیب ایرانی',
  url: SibIraniDownloadUrl,
  imageUrl: getCdnUrl('/_toad/images/footer/download-from-sibirani.png')
}];
export const certificatesLinks: Partial<Link>[] = [{
  name: 'ستاد ساماندهی پایگاه‌های اینترنتی',
  popup: {
    url: 'https://logo.samandehi.ir/Verify.aspx?id=172500&p=rfthjyoeuiwkdshwobpdobpd',
    options: 'toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30'
  },
  imageUrl: getCdnUrl('/_toad/images/footer/samandehi-logo.png')
}, {
  name: 'اتحادیه کشوری کسب و کارهای مجازی',
  popup: {
    url: 'https://ecunion.ir/verify/khanoumi.com?token=76529895ff992e93d8c2',
    options: 'toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30'
  },
  imageUrl: getCdnUrl('/_toad/images/footer/credit-union.png')
}];
export const featureIcons = [{
  title: 'نماد اعتماد',
  description: 'پرداخت امن',
  imageUrl: '/Scripts/UI/css/ThemeFiles/images/Diamond.svg'
}, {
  title: 'نحوه پرداخت',
  description: 'تمامی کارتهای عضو شتاب',
  imageUrl: '/Scripts/UI/css/ThemeFiles/images/Wallet.svg'
}, {
  title: 'ارسال رایگان',
  description: 'جزئیات هزینه ارسال',
  url: '/faq/#delivery',
  imageUrl: '/Scripts/UI/images/free-shipping.svg'
}, {
  title: '۷ روز بازگشت رایگان',
  description: 'شرایط خدمات پس از فروش',
  url: '/faq/#return',
  imageUrl: '/Scripts/UI/css/ThemeFiles/images/7-Day.svg'
}];
export const SocialIconsDetails = [{
  name: 'Pinterest',
  url: TelegramUrl,
  icon: <IconTelegramNegative className='h-6 w-6' />
}, {
  name: 'Linkedin',
  url: LinkedinUrl,
  icon: <IconLinkedInNegative className='h-6 w-6' />
}, {
  name: 'Instagram',
  url: InstagramUrl,
  icon: <IconInstagramNegative className='h-6 w-6' />
}];
export const TopBrandsAwardLink = 'https://irantopbrands.org/برند_محبوب_1402';